

<p-dialog header="Loading runs" [(visible)]="importingRuns" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false" [closable]="false">
    <p class="m-0">
        Loading new runs, please wait.
    </p>
</p-dialog>
<p-dialog header="Sending Data to Azure" [(visible)]="sendingData" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false" [closable]="false">
    <p class="m-0">
        Sending data to storage, please wait.  This operation can take upwards of 3 hours.
    </p>
</p-dialog>
<p-dialog header="Approving and Sending Data to One Codex/Internal Storage" [(visible)]="sendingDataToOC" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false" [closable]="false">
    <p class="m-0">
        Approving and sending data to One Codex/Internal Storage, please wait.  This operation can take a while depending on the size of the run.
    </p>
</p-dialog>
<p-card>
    <p-table [value]="runList" [tableStyle]="{'min-width': '50rem'}" #dt [loading]="loading"
        [rows]="50" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" 
        [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [columns]="cols"
        stateStorage="local" stateKey="runlist-state">
        <ng-template pTemplate="caption">
            <div class="">
                <button pButton type="button" label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt)"></button>
                <button type="button" pButton icon="pi pi-file" iconPos="left" label="Export" (click)="dt.exportCSV()" style="margin-left: 0.5em;"></button>
                <button type="button" pButton icon="pi pi-plus-circle" iconPos="left" label="Import Runs" (click)="importRuns()" style="float:right;"></button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr> 
                <!--th pSortableColumn="importDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Import Date
                        <p-sortIcon field="importDate"></p-sortIcon>
                        <p-columnFilter type="date" field="importDate" display="menu"></p-columnFilter>
                    </div>
                </th-->
                <th pSortableColumn="processedDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Import Date
                        <p-sortIcon field="processedDate"></p-sortIcon>
                        <p-columnFilter type="date" field="processedDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="name" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Run Name
                        <p-sortIcon field="name"></p-sortIcon>
                        <p-columnFilter type="text" field="name" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="autoApproved" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Auto Approved
                        <p-sortIcon field="autoApproved"></p-sortIcon>
                        <p-columnFilter type="bool" field="autoApproved" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="sequencingMethod" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Sequencing Method
                        <p-sortIcon field="sequencingMethod"></p-sortIcon>
                        <p-columnFilter type="text" field="sequencingMethod" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Run QC
                    </div>
                </th>
                <th style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Samples
                    </div>
                </th>
                <th style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Approve
                    </div>
                </th>
                <th style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Retest
                    </div>
                </th>
                <th style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Send to Storage
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-run>
            <tr (click)="rowClick(run)">
                <td>{{run.processedDate | date:'short'}}</td>
                <td>{{run.name}}</td>
                <td>{{run.autoApproved}}</td>
                <td>{{run.sequencingMethod?.friendlyName}}</td>
                <td><button pButton type="button" label="View QC" (click)="viewRunDetail(run)"></button></td>
                <td><button pButton type="button" label="Samples" (click)="viewSampleList(run)"></button></td>
                <td><button pButton [disabled]="!run.openSamples" type="button" label="Approve" (click)="approve(run)"></button></td>
                <td><button pButton [disabled]="!run.openSamples" type="button" label="Retest" (click)="retest(run)"></button></td>
                <td><button pButton [disabled]="run.sentToStorage" type="button" label="Send" (click)="sendRunToStorage(run)"></button></td>
            </tr>
        </ng-template>
    </p-table>
</p-card>